import Button from 'components/ui/Button/Button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPreferredHotel } from 'services/hotel';
import { PreferedResponse } from 'ts/hotel/interfaces/HotelResponse';
import Skeleton from 'react-loading-skeleton';
import ReactDOM from 'react-dom';
import MaximizeModal from 'components/shared/MaximizeModal';
import ScreenshotSupport from 'components/shared/ScreenshotSupport';
import useDraggableModal from 'hooks/useDraggableModal';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { Hotel } from 'ts/hotel/interfaces/HotelResponse';

import { getKey } from 'utils/hotel';
import { HotelConfigContext } from 'contexts/HotelConfigContext';

interface PreviewPreferredHotelModalProps {
  onClose: () => void;
  hotel: Hotel;
}

const PreviewPreferredHotelModal: FC<PreviewPreferredHotelModalProps> = ({ onClose, hotel }) => {
  const [t] = useTranslation();
  const [data, setData] = useState<PreferedResponse>();
  const { hotelIndex } = useContext(HotelConfigContext);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);
  const modalOverlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    (async () => {
      const newData = await getPreferredHotel({
        hotelItemBPID: hotel.item?.bpid || '',
        searchToken: sessionStorage.getItem(getKey('searchTokenHotels', hotelIndex)) || '',
      });

      if (newData && !newData.hasErrors) {
        setData(newData);
      }
    })();
  }, []); // eslint-disable-line

  return ReactDOM.createPortal(
    <div
      ref={modalOverlayRef}
      className="modal-overlay modal-overlay-top modal-maximizable"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div ref={modalRef} className={'modal modal-sm active'} style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <div className="mb-10">
            <h5 className="text-bold text-md text-uppercase mb-5">{hotel.item?.name}</h5>
            <div className="text-light">{hotel.addressInfo?.address}</div>
          </div>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes} onClick={() => onClose()} />
          </div>
        </div>

        <div className="modal-content">
          {!data && (
            <div>
              <Skeleton count={4} height={16} className="mb-5" />
            </div>
          )}

          {data?.preferedDataList.map((item, index) => (
            <div key={index}>
              {!!item.positiveReviews?.length && (
                <div className="text-success mb-10">
                  <div className="mb-10 text-bold">{t('hotel.positive_reviews')}</div>
                  {item.positiveReviews.map((it, i) => (
                    <div className="ml-5 mb-5" key={i}>
                      {it.desc}
                    </div>
                  ))}
                </div>
              )}
              {!!item.negativeReviews?.length && (
                <div className="color-danger mb-10">
                  <div className="mb-10 text-bold">{t('hotel.negative_reviews')}</div>
                  {item.negativeReviews.map((it, i) => (
                    <div className="ml-5 mb-5" key={i}>
                      {it.desc}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default withErrorBoundary(PreviewPreferredHotelModal, 'PreviewPreferredHotelModal');
